<div class="animated fadeIn wb-ball">
  <h1 mat-dialog-title>
    {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.TITLE-2' | translate }}
  </h1>
  <form [formGroup]="downloadConfirmForm" (ngSubmit)="onDownload()">
    <div mat-dialog-content>
      <p class="w-100 m-0">
        {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.DOWNLOAD-CODE' | translate }}
      </p>
        <mat-form-field class="w-100">
          <input matInput [attr.data-selenium]="'input-download-code'" cdkFocusInitial [placeholder]="'CERTIFICATES.TABS.PRIVATE.LABELS.INSERT-DOWNLOAD-CODE' | translate" type="text" formControlName="downloadingCode" required autocomplete="nope">
          <mat-hint class="text-danger animated fadeInDown" *ngIf="isFieldRequired('downloadingCode')">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>

        <p class="w-100 pt-3 m-0">
          {{ 'CERTIFICATES.TABS.PRIVATE.LABELS.DETAIL-2' | translate }}
        </p>
        <mat-form-field class="w-100">
          <input matInput [attr.data-selenium]="'input-copy-password'" [placeholder]="'CERTIFICATES.TABS.PRIVATE.LABELS.INSERT-PASS' | translate" [type]="hide ? 'password' : 'text'" formControlName="passwordToEncrypt" required autocomplete="new-password">
          <mat-icon matSuffix [attr.data-selenium]="'toggle-copy-password'" class="mx-2" color="primary" (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="isFieldRequired('passwordToEncrypt')">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
        </mat-form-field>

        <mat-form-field class="w-100">
          <input matInput [attr.data-selenium]="'input-copy-repeat-password'" [placeholder]="'CERTIFICATES.TABS.PRIVATE.LABELS.REPEAT-PASSWORD-CERT' | translate" [type]="hide2 ? 'password' : 'text'" #passwordToEncryptConfirm formControlName="passwordToEncryptConfirm" required autocomplete="new-password">
          <mat-icon matSuffix [attr.data-selenium]="'toggle-copy-password'" class="mx-2" color="primary" (click)="hide2 = !hide2">{{hide2 ? 'visibility' : 'visibility_off'}}</mat-icon>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="isFieldRequired('passwordToEncryptConfirm')">{{ 'GLOBAL.ERRORS.REQUIRED' | translate }}</mat-hint>
          <mat-hint class="text-danger animated fadeInDown" *ngIf="downloadConfirmForm.errors?.fieldsDontMatch">{{ 'GLOBAL.ERRORS.PASS-NO-EQUAL' | translate }}</mat-hint>
        </mat-form-field>
    </div>
    <div mat-dialog-actions class="w-100">
      <button mat-raised-button color="primary" class="ms-2 float-end" [attr.data-selenium]="'button-confirm-pass'" [disabled]="" type="submit">
        <i class="rt-icon rt-descargar-2" *ngIf="isMobile"></i>
        <span *ngIf="!isMobile">{{ 'GLOBAL.DOWNLOAD' | translate }}</span>
      </button>
      <button mat-stroked-button color="primary" [attr.data-selenium]="'button-cancel'" class="" (click)="onNoClick()" type="button">
        <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
        <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
      </button>
    </div>
  </form>
</div>
